import { Component, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  OnyxIconBoxComponent,
  OnyxIconComponent,
  OnyxPhoneNumberInputComponent,
  OnyxTextareaComponent,
  OnyxTextFieldComponent,
} from '@onyx/angular';
import type { OrderPointFormGroup } from '../order-point-form.component';

@Component({
  selector: 'app-order-point-information-form',
  imports: [
    OnyxTextareaComponent,
    OnyxIconBoxComponent,
    OnyxTextFieldComponent,
    OnyxPhoneNumberInputComponent,
    ReactiveFormsModule,
    OnyxIconComponent,
  ],
  templateUrl: './order-point-information-form.component.html',
  styleUrl: './order-point-information-form.component.scss',
  host: { '[class.compact]': `compact()` },
})
export class OrderPointInformationFormComponent {
  public readonly form = input.required<OrderPointFormGroup>();
  public readonly compact = input(false);
}
